import React, {useState} from "react";
import FormEx from "@/components/FormEx";
import {FormItemEx} from "@/components/FormItemEx";
import {logisticsType} from "@/pages/order/interface";
import QuickFilter from "@/pages/order/components/quickFilter";
import {formatParams} from "@/components/FormEx/helper";
import {ISelect} from "@/components/Select/helper";

interface Props {
    setParams: any
    params: any
    orderStat: ISelect[]
    paymentStat: ISelect[]
}


const OrderFilter = (props: Props) => {
    const {setParams, params, orderStat, paymentStat} = props
    const [keyword, setKeyword] = useState<string>('')
    const onFinish = (e: any) => setParams(formatParams(e))
    const attr = (label: string) => {
        return {
            width: 210,
            labelwidth: 80,
            size: 'small',
            filter: true,
            label
        }
    }
    const onKeyUp = (e: any) => {
        if (e.keyCode === 13) {
            setParams(formatParams({...params, KeyWord: keyword}))
        }

    }
    return (
        <>
            <FormEx onFinish={onFinish} initialValues={params} onSearch={onFinish}>
                <FormItemEx onKeyUp={onKeyUp} type="input" fld='KeyWord' {...attr('关键字')}
                            placeholder='订单号、追踪号、仓库代码、货件编号、产品名称'
                            labelwidth={65}
                            onChange={setKeyword}
                            labelAlign='left'
                            width={310}/>
                <FormItemEx type="picker" fld='StartTime' {...attr('开始时间')} />
                <FormItemEx type="picker" fld='EndTime' {...attr('结束时间')} />
                <FormItemEx type="select" fld='method' {...attr('物流方式')} items={logisticsType}/>
                <button className="primary-button" type='submit' style={{height: '34px'}}>搜索</button>
                <input className="grey-button" type='reset' style={{marginLeft: '10px', height: '34px'}} value='重置'/>
            </FormEx>
            <div className='flex'>
                <QuickFilter setParams={setParams} stat={orderStat} fields='OrderState' params={params}/>
                &emsp;&emsp;
                <QuickFilter setParams={setParams} stat={paymentStat} fields='PaymentState' params={params}/>
            </div>

        </>
    )
}

export default OrderFilter